import { render, staticRenderFns } from "./VendasComparativoFaturamentoVolume.vue?vue&type=template&id=ad39acca&scoped=true&"
import script from "./VendasComparativoFaturamentoVolume.vue?vue&type=script&lang=js&"
export * from "./VendasComparativoFaturamentoVolume.vue?vue&type=script&lang=js&"
import style0 from "./VendasComparativoFaturamentoVolume.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./VendasComparativoFaturamentoVolume.vue?vue&type=style&index=1&id=ad39acca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad39acca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VContainer,VIcon,VRadio,VRadioGroup,VRow})
